import {Drawer} from 'presentation/components/Drawer';
import {Filter} from 'presentation/components/Filter';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {useMyHospitalizationFilterHeader} from '../../hooks/useMyHospitalizationFilterHeader';
import {FilterDrawerProps} from './types';

const {filterAuthorizations} = translations['pt-br'].commons;

export const FilterDrawer = ({listDrawerItens, titleListDrawer}: FilterDrawerProps) => {
	const {isMobile} = useMediaQueries();
	const {
		handleApplyFilter,
		handleClearFilter,
		handleCloseDrawer,
		handleOpenDrawer,
		listFilters,
		openDrawerState,
		IS_ALL,
	} = useMyHospitalizationFilterHeader({listDrawerItens, titleListDrawer});

	return (
		<Fragment>
			<Filter.Button onClick={handleOpenDrawer} count={IS_ALL ? 0 : 1} />
			<Drawer.Root
				open={openDrawerState}
				onOpen={handleOpenDrawer}
				width="685px"
				onClose={() => handleCloseDrawer()}
				sx={{zIndex: 9000}}>
				<Drawer.Header
					title={filterAuthorizations}
					onClose={() => handleCloseDrawer()}
					containerPadding={isMobile ? '0 8px 16px 16px' : '0 16px 16px 24px'}
				/>
				{listDrawerItens ? (
					<Drawer.ContentListByCategory categoryList={listFilters} />
				) : null}
				<Drawer.Footer
					firstButtonOnClick={handleClearFilter}
					secondButtonOnClick={handleApplyFilter}
				/>
			</Drawer.Root>
		</Fragment>
	);
};
